/**
 * SEO Configuration for BD Live Cric - Bangladesh Market Optimized
 * Focus: Cricket, Football, Live Sports Streaming in Bangladesh
 */

export const SEO_CONFIG = {
  siteName: 'BD Live Cric',
  siteUrl: 'https://bdlivecric.com',
  locale: 'bn_BD', // Bengali Bangladesh
  
  // Global Meta Tags
  global: {
    title: 'BD Live Cric - লাইভ ক্রিকেট, ফুটবল স্ট্রিমিং বাংলাদেশ | Free Live Sports',
    description: 'বাংলাদেশে লাইভ ক্রিকেট ম্যাচ, ফুটবল এবং অন্যান্য খেলাধুলা বিনামূল্যে স্ট্রিমিং করুন। BD Live Cric এ সব সময় সর্বশেষ ক্রিকেট লাইভ দেখুন।',
    keywords: 'লাইভ ক্রিকেট, live cricket Bangladesh, ক্রিকেট স্ট্রিমিং, cricket streaming, ফুটবল স্ট্রিমিং, football streaming, BD sports, বাংলাদেশ খেলাধুলা, free sports streaming, live sports Bangladesh',
    image: 'https://bdlivecric.com/og-image.jpg',
    twitterHandle: '@bdlivecric',
    authorName: 'BD Live Cric',
    locale: 'bn_BD'
  },

  // Pages Configuration
  pages: {
    home: {
      title: 'BD Live Cric - বাংলাদেশে লাইভ ক্রিকেট এবং ফুটবল দেখুন বিনামূল্যে',
      description: 'BD Live Cric এ লাইভ ক্রিকেট ম্যাচ, ফুটবল গেম এবং আরও অনেক খেলাধুলা বিনামূল্যে স্ট্রিমিং করুন। বাংলাদেশে সেরা লাইভ স্পোর্টস প্ল্যাটফর্ম।',
      keywords: 'লাইভ ক্রিকেট, ক্রিকেট স্ট্রিমিং বাংলাদেশ, লাইভ ফুটবল, খেলাধুলা লাইভ',
    },
    events: {
      title: 'সকল লাইভ ইভেন্ট - BD Live Cric',
      description: 'বাংলাদেশে সকল লাইভ ক্রিকেট ম্যাচ, ফুটবল এবং খেলাধুলার ইভেন্ট দেখুন। আপডেট হওয়া শিডিউল এবং লাইভ স্ট্রিমিং।',
      keywords: 'cricket events Bangladesh, football events, live events, sports schedule',
    },
    eventDetail: {
      titleTemplate: '{eventName} - লাইভ স্ট্রিমিং | BD Live Cric',
      descriptionTemplate: '{eventName} এর লাইভ স্ট্রিমিং এখানে দেখুন। {teams} ম্যাচ বাংলাদেশে সরাসরি লাইভ সম্প্রচার।',
    }
  },

  // Open Graph Configuration
  openGraph: {
    type: 'website',
    locale: 'bn_BD',
    image: {
      url: 'https://bdlivecric.com/og-image.jpg',
      width: 1200,
      height: 630,
      alt: 'BD Live Cric - বাংলাদেশের লাইভ ক্রিকেট এবং ফুটবল স্ট্রিমিং প্ল্যাটফর্ম'
    }
  },

  // Twitter Card
  twitter: {
    card: 'summary_large_image',
    site: '@bdlivecric',
    creator: '@bdlivecric'
  },

  // Schema.org Structured Data
  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'BD Live Cric',
    url: 'https://bdlivecric.com',
    logo: 'https://bdlivecric.com/logo.png',
    description: 'বাংলাদেশে লাইভ ক্রিকেট এবং ফুটবল স্ট্রিমিং প্ল্যাটফর্ম',
    sameAs: [
      'https://www.facebook.com/bdlivecric',
      'https://www.twitter.com/bdlivecric',
      'https://www.instagram.com/bdlivecric'
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+880-1XXX-XXXXXX',
      contactType: 'Customer Service',
      areaServed: 'BD'
    },
    areaServed: 'BD',
    foundingDate: '2024',
    operatingCountry: 'BD'
  },

  // Localized Keywords by Sport & Region
  keywords: {
    cricket: [
      'লাইভ ক্রিকেট',
      'cricket streaming',
      'বিডি ক্রিকেট',
      'বাংলাদেশ ক্রিকেট লাইভ',
      'cricket Bangladesh live',
      'টেস্ট ম্যাচ লাইভ',
      'ওডিআই লাইভ',
      'টি-২০ লাইভ',
      'পিএসএল লাইভ',
      'বিপিএল লাইভ',
      'ভারত বাংলাদেশ ক্রিকেট',
      'পাকিস্তান বাংলাদেশ ক্রিকেট',
      'বিশ্বকাপ লাইভ',
      'এশিয়া কাপ লাইভ'
    ],
    football: [
      'ফুটবল স্ট্রিমিং',
      'football live',
      'সাফ ফুটবল',
      'বাংলাদেশ ফুটবল লাইভ',
      'প্রিমিয়ার লিগ লাইভ',
      'ইউরোপা লিগ লাইভ',
      'চ্যাম্পিয়নস লিগ লাইভ',
      'বিশ্বকাপ ফুটবল',
      'আইপিএল ফুটবল'
    ],
    region: [
      'ঢাকা স্পোর্টস',
      'চট্টগ্রাম ক্রিকেট',
      'বাংলাদেশ লাইভ স্পোর্টস',
      'সিলেট ক্রিকেট',
      'বরিশাল ফুটবল',
      'BD live sports',
      'Bangladesh streaming',
      'Dhaka sports live'
    ]
  },

  // Alternate Languages
  alternateLanguages: [
    { hrefLang: 'en-BD', label: 'English (Bangladesh)' },
    { hrefLang: 'bn-BD', label: 'Bengali (Bangladesh)' },
    { hrefLang: 'en', label: 'English' }
  ]
};

// Category-specific descriptions
export const CATEGORY_DESCRIPTIONS = {
  Cricket: 'লাইভ ক্রিকেট ম্যাচ, টেস্ট, ওডিআই, টি-২০, পিএসএল এবং বিপিএল স্ট্রিমিং',
  Football: 'লাইভ ফুটবল ম্যাচ, প্রিমিয়ার লিগ, চ্যাম্পিয়নস লিগ এবং আরও অনেক কিছু'
};

// Rich Snippet Templates
export const RICH_SNIPPETS = {
  sportEvent: (event: any) => ({
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name: event.name,
    description: `${event.name} - ${event.location} এ অনুষ্ঠিত হবে`,
    startDate: event.startDate,
    endDate: event.endDate,
    location: {
      '@type': 'Place',
      name: event.location,
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'BD'
      }
    },
    organizer: {
      '@type': 'Organization',
      name: 'BD Live Cric',
      url: 'https://bdlivecric.com'
    },
    competitor: [
      {
        '@type': 'SportsTeam',
        name: event.teamA
      },
      {
        '@type': 'SportsTeam',
        name: event.teamB
      }
    ]
  })
};
